<h1>Profil</h1>
<div class="mb-4">
  <span class="mr-2">
    {{ currentUser().fornavn }} {{ currentUser().efternavn }} ({{
      currentUser().email
    }})
  </span>
  <i
    title="Kopier access token"
    (click)="onClickCopyToken()"
    class="pi pi-unlock cursor-pointer"></i>
</div>
<p-button label="Log ud" (click)="onClickLogout()"></p-button>
<p-divider></p-divider>
<h2>Rettigheder</h2>
<ul>
  @for (r of currentUser().rettigheder; track r) {
    <li>{{ r }}</li>
  }
</ul>
